import { createContext } from "react";

// Opt-in only. Existing chart screens keep their rendering and loading behavior.
export const NoteChartRenderContext = createContext(false);
